export default __webpack_public_path__ + "47ba874108a8f658f23d2cffdb3f780a.png";